const actions = {
  SET_STATE: 'share/SET_STATE',
  GET_SHARE_CAPITAL_SUMMARY: 'share/GET_SHARE_CAPITAL_SUMMARY',
  DISPLAY_SHARE_CAPITAL_ACCOUNT: 'share/DISPLAY_SHARE_CAPITAL_ACCOUNT',
  GET_SHARE_HISTORY_TABLE: 'share/GET_SHARE_HISTORY_TABLE',
  GET_SHARE_AUTOCOMPLETE: 'share/GET_SHARE_AUTOCOMPLETE',
}

export default actions
